<div class="w-full max-w-6xl p-4 sm:p-6 lg:p-8">
    <div class="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div class="prose prose-sm max-w-none">
            <h2 class="m-0">{{ 'label_paychecks_for_printout' | translate }}</h2>
            <p class="m-0 text-secondary">{{ 'info_paychecks_for_printout' | translate }}</p>
        </div>

        <div class="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-2">
            <button mat-flat-button color="primary" class="w-full sm:w-auto" (click)="copyLink()" [disabled]="isLoading">
                <mat-icon class="icon-size-5 pr-1" [svgIcon]="'heroicons_outline:link'"></mat-icon>
                {{ 'label_copy_link' | translate }}
            </button>

            <button mat-stroked-button class="w-full sm:w-auto" (click)="openInNewTab()" [disabled]="!pdfFrameUrl || isLoading">
                <mat-icon class="icon-size-5 pr-1" [svgIcon]="'heroicons_outline:arrow-top-right-on-square'"></mat-icon>
                {{ 'label_open_in_new_tab' | translate }}
            </button>

            <button mat-stroked-button class="w-full sm:w-auto" [matMenuTriggerFor]="moreMenu" [disabled]="!pdfFrameUrl || isLoading">
                <mat-icon class="icon-size-5 pr-1" [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                {{ 'label_more' | translate }}
            </button>
            <mat-menu #moreMenu="matMenu">
                <button mat-menu-item (click)="print()" [disabled]="!pdfFrameUrl">{{ 'label_print' | translate }}</button>
                <button mat-menu-item (click)="downloadPdf()" [disabled]="!pdfFrameUrl">{{ 'label_get' | translate }}</button>
            </mat-menu>
        </div>
    </div>

    <div class="mt-4">
        @if (!hasPaycheckRunsRole && !isLoading) {
            <div class="rounded-lg border p-4 text-sm">
                <div class="text-lg font-bold mb-1">Aðgang vantar</div>
                <div class="text-md text-secondary">
                    Þú hefur ekki aðgang að launaseðlavinnslum. Hafðu samband við upplýsingatæknideild LSR.
                </div>
            </div>
        } @else {
            @if (isLoading) {
                <div class="rounded-lg border p-4 text-sm">{{ 'label_get_and_merge_pdf' | translate }}</div>
            }
            @if (errorMessage && !isLoading) {
                <div class="rounded-lg border p-4 text-sm">
                    <div class="text-md mb-3">Ekki tókst að sækja PDF skjalið.</div>
                    <button mat-stroked-button color="primary" (click)="retry()">{{ 'label_try_again' | translate }}</button>
                </div>
            }
            @if (pdfFrameUrl && !isLoading) {
                <div class="overflow-hidden rounded-lg border bg-white">
                    <iframe
                        #viewerFrame
                        [src]="pdfFrameUrl"
                        title="Launaseðlar PDF"
                        class="block w-full h-[70vh] sm:h-[78vh] lg:h-[82vh]"
                    ></iframe>

                    <iframe #printFrame class="fixed right-0 bottom-0 w-px h-px opacity-0 border-0"></iframe>
                </div>
            }
        }
    </div>
</div>
